export const colors = ["orange", "blue", "pink", "green", "red", "yellow", "gray", "white"] as const;

export const variants = ["light", "lighter", "dark", "darker", "1", "2", "3", "4", "5", "6", "7", "8", "9"] as const;

export type Color = (typeof colors)[number];

export type ColorVariant = (typeof variants)[number];

export const getCssVariable = function (color: Color, variant?: ColorVariant) {
  if (variant) return `var(--${color}-${variant})`;
  else return `var(--${color})`;
};

export const getColorFromKey = (text: string): Color => {
  // Sum the ASCII values of characters in the user ID
  const asciiSum = text.split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);

  // Calculate the index by taking the modulo of the sum with the length of the colors array
  const index = asciiSum % colors.length;

  // Return the color at the calculated index
  return colors[index];
};

// The idea is to pick a color not only from the colors array but also from the variants array
// We want to have a cycle of colors and variants
// For example, if we have 3 colors and 2 variants, we want to have the following cycle:
// 0 -> color 0, variant 0
// 1 -> color 1, variant 0
// 2 -> color 2, variant 0
// 3 -> color 0, variant 1
// 4 -> color 1, variant 1
// 5 -> color 2, variant 1
export const getColorFromIndex = (index: number): { color: Color; variant?: ColorVariant } => {
  const colorCount = colors.length;

  // Which cycle are we in? 0 = base, 1 = first variant, etc.
  const cycle = Math.floor(index / colorCount);
  const color = colors[index % colorCount];

  const variant = cycle === 0 ? undefined : variants[cycle - 1];

  return { color, variant };
};

export const getCssVariableFromIndex = (index: number) => {
  const { color, variant } = getColorFromIndex(index);
  return getCssVariable(color, variant);
};
